/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm, replacePXinStringWithEM } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : REPORT DIMENSIONS --------------- ++++++++++ */
export default theme => ({
	dimensions: {
		
	}
});
